

















import { Component, Vue, Mixins, Watch } from "vue-property-decorator";
// 组件
import Header from "./components/Header.vue";
import Table from "./components/Table.vue";
import Dialog from "./components/Dialog.vue";
// 混入
import Loading from "@/mixins/loading";
// 工具
import debounce from "@/utils/debounce";
import copy from "@/utils/deepCopy";
// api
import { AddRecharge } from "@/types/api/recharge";

const initForm: AddRecharge = {
  chargeAmount: "",
  createTime: "",
  deleteStatus: 0,
  description: "",
  experiencePoint: "",
  giveAmount: "",
  id: 0,
  sort: 0,
};

@Component({
  components: {
    Table,
    Header,
    Dialog,
  },
})
export default class Vip extends Mixins(Loading) {
  dialogVisible: boolean = false;
  form: AddRecharge = initForm;
  type: string = "add"; // add:添加  edit:编辑
  // 新建充值
  handleAdd(): void {
    this.type = "add";
    this.dialogVisible = true;
    this.form = copy(initForm);
  }

  // 编辑
  handleEdit(row: AddRecharge): void {
    this.type = "edit";
    this.dialogVisible = true;
    this.form = copy(row);
  }

  // 关闭对话框
  closeDialog() {
    this.dialogVisible = false;
  }

  // 获取数据
  getData() {
    let table: any = this.$refs.table;
    table.getData();
  }
}
